const CHARTING_LIBRARY_PREFIX = "charting_library.";

/**
 * Collect Redux translation phrases for Charting Library custom_translate_function.
 * @param {Record<string, string>|null|undefined} phrases Locale phrase map
 * @returns {Record<string, string>}
 */
export default function buildTvChartBridgeChartingLibraryTranslations(
  phrases
) {
  const result = {};

  if (!phrases || typeof phrases !== "object") {
    return result;
  }

  Object.keys(phrases).forEach(key => {
    if (key.indexOf(CHARTING_LIBRARY_PREFIX) === 0) {
      result[key] = phrases[key];
    }
  });

  return result;
}

export { CHARTING_LIBRARY_PREFIX };
